import { useEffect, useState, useCallback } from 'react'
import styles from './Toast.module.css'

interface ToastItem {
  id: number
  msg: string
}

let _showToast: ((msg: string) => void) | null = null
let _toastId = 0

export function showToast(msg: string) {
  _showToast?.(msg)
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([])

  const removeToast = useCallback((id: number) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  useEffect(() => {
    _showToast = (msg: string) => {
      const id = ++_toastId
      setToasts(prev => [...prev, { id, msg }])
      setTimeout(() => removeToast(id), 2000)
    }
    return () => { _showToast = null }
  }, [removeToast])

  if (toasts.length === 0) return null

  return (
    <div className={styles.toastContainer}>
      {toasts.map(t => (
        <div key={t.id} className={styles.toast}>
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  )
}
